module.exports = __webpack_public_path__ + "img/1534409014.5840d198.jpg";